import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';
import { AuthContext } from '../context/AuthContext';
import { getPortalPath } from '../utils/roleRedirect';

/**
 * RoleRoute — requires authentication AND membership in `roles`.
 * - loading auth state → spinner
 * - unauthenticated → /login
 * - authenticated but wrong role → that user's own portal
 * - authenticated and role matches → renders children
 */
function RoleRoute({ roles, children }) {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const allowed = roles.map((r) => r.toLowerCase());
  if (!allowed.includes(String(user.role || '').toLowerCase())) {
    return <Navigate to={getPortalPath(user.role)} replace />;
  }

  return children;
}

RoleRoute.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};

export default RoleRoute;
